<!--
    @author qixf@thinkerx.com
    @remark 系统管理-功能模块管理
    @created 2020/5/28
-->
<template>
  <div>
    <!-- 操作按钮 -->
    <div style="margin: 15px 0;">
      <el-button type="danger" icon="el-icon-plus" @click="openDialog()">添加</el-button>
    </div>
    <!-- 表格 -->
    <el-table border stripe :data="list" style="width: 100%;">
      <el-table-column type="index" label="序号" width="60"></el-table-column>
      <el-table-column prop="name" label="名称"></el-table-column>
      <el-table-column label="类型" width="120">
        <template slot-scope="scope">
          {{scope.row.type==1?'功能推荐':'产品推荐'}}
        </template>
      </el-table-column>
      <el-table-column label="图标" width="110">
        <template slot-scope="scope">
          <img v-if="scope.row.icon" :src="scope.row.icon" style="max-width: 90px;max-height: 90px;" />
        </template>
      </el-table-column>
      <el-table-column label="展示图片" width="170">
        <template slot-scope="scope">
          <img v-if="scope.row.pic_url" :src="scope.row.pic_url" style="max-width: 150px;max-height: 150px;" />
        </template>
      </el-table-column>
      <el-table-column label="价格" width="120" prop="price"></el-table-column>
      <el-table-column label="可试用天数" width="120" prop="try_days"></el-table-column>
      <el-table-column label="操作" width="200" fixed="right">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="openDialog(scope.row)">编辑</el-button>
          <el-button type="danger" size="mini" @click="deleteReport(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div style="height: 100px;"></div>

    <!-- 添加、编辑模块 弹窗 -->
    <el-dialog :title="modules.id?'编辑模块':'添加模块'"
      :visible.sync="open_dialog" width="700px">
      <el-form ref="form" :model="modules" :rules="rules" label-width="100px">
        <el-form-item label="名称" prop="name">
          <el-input v-model="modules.name"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input-number v-model="modules.sort" :step="1" step-strictly></el-input-number>
        </el-form-item>
        <el-form-item label="类型">
          <el-radio v-model="modules.type" :label="1">功能推荐</el-radio>
          <el-radio v-model="modules.type" :label="2">产品推荐</el-radio>
        </el-form-item>
        <el-form-item label="图标">
          <el-upload ref="upload" action="" :http-request="()=>{}"
                     :file-list="file_list.icon" list-type="picture"
                     :on-change="(file,fileList)=> { file_list.icon = [file] }"
                     :on-remove="(file,fileList)=> { file_list.icon = fileList }">
            <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="标签">
          <el-input v-model="modules.label" placeholder="以 | 分割，生成多个标签"></el-input>
        </el-form-item>
        <el-form-item label="描述" v-show="modules.type==2">
          <el-input v-model="modules.description" type="textarea" :rows="2"></el-input>
        </el-form-item>
        <el-form-item :label="modules.type==1?'功能亮点':'面临问题'">
          <el-input v-model="modules.info" type="textarea" :rows="5" placeholder="以 | 分割，生成多个点"></el-input>
        </el-form-item>
        <el-form-item label="展示图片">
          <el-upload ref="upload" action="" :http-request="()=>{}"
                     :file-list="file_list.pic_url" list-type="picture"
                     :on-change="(file,fileList)=> { file_list.pic_url = [file] }"
                     :on-remove="(file,fileList)=> { file_list.pic_url = fileList }">
            <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
          </el-upload>
        </el-form-item>

        <el-form-item label="价格" prop="price" v-show="modules.type==1">
          <el-input-number v-model="modules.price" :precision="2" :step="1" :min="0"></el-input-number>
        </el-form-item>
        <el-form-item label="可试用天数" prop="try_days" v-show="modules.type==1">
          <el-input-number v-model="modules.try_days" :step="1" step-strictly :min="0"></el-input-number>
        </el-form-item>
        <el-form-item label="key" v-show="modules.type==1">
          <el-input v-model="modules.key" placeholder="与前端人员对接协商"></el-input>
        </el-form-item>

        <el-form-item label="免费试用url" v-show="modules.type==2">
          <el-input v-model="modules.try_url"></el-input>
        </el-form-item>
        <el-form-item label="购买正式版url" v-show="modules.type==2">
          <el-input v-model="modules.official_url"></el-input>
        </el-form-item>
        <el-form-item label="查看视频url" v-show="modules.type==2">
          <el-input v-model="modules.video_url"></el-input>
        </el-form-item>
        <el-form-item label="使用手册url" v-show="modules.type==2">
          <el-input v-model="modules.help_url"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="open_dialog = false">取消</el-button>
        <el-button type="primary" @click="submit" :loading="is_save">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "modules-manager",
  data() {
    return {
      list: [],
      open_dialog: false,
      modules: {
        id: '', name: '', type: 1, label: '', sort: 0,
        icon: '', pic_url: '', info: '', description: '',
        price: 0, try_days: 0,  key: '',
        try_url: '', official_url: '', video_url: '', help_url: ''
      },
      file_list: {
        icon: [], pic_url: [],
      },
      rules: {
        name: [
          { required: true, trigger: 'submit', message: '请输入名称' }
        ],
        sort: [
          { type: 'number', trigger: 'submit', message: '请输入数字' }
        ],
        price: [
          { type: 'number', trigger: 'submit', message: '请输入数字' }
        ],
        try_days: [
          { type: 'number', trigger: 'submit', message: '请输入数字' }
        ],
      },
      is_save: false,
    }
  },
  methods: {
    /** 获取列表 **/
    getList() {
      this.$axios.get("modules").then(res => {
        this.list = res.data;
      });
    },
    /** 打开 添加、编辑模块 弹窗 **/
    openDialog(modules) {
      this.file_list = { pic_url: [], icon: [] };
      if (modules) {
        this.modules = {
          id: modules.id, name: modules.name, type: modules.type, label: modules.label,
          sort: modules.sort,
          icon: modules.icon, pic_url: modules.pic_url, info: modules.info, description: modules.description,
          price: modules.price, try_days: modules.try_days,  key: modules.key,
          try_url: modules.try_url, official_url: modules.official_url, video_url: modules.video_url,
          help_url: modules.help_url
        };
        if (modules.pic_url) this.file_list.pic_url = [{ name: "展示图片", url: modules.pic_url }];
        if (modules.icon) this.file_list.icon = [{ name: "图标", url: modules.icon }];
      }
      else
        this.modules = {
          id: '', name: '', type: 1, label: '', sort: this.list.length+1,
          icon: '', pic_url: '', info: '', description: '',
          price: 0, try_days: 0,  key: '',
          try_url: '', official_url: '', video_url: '', help_url: ''
        };
      this.open_dialog = true;
    },
    /** 提交 **/
    async submit() {
      let is_valid = true;
      this.$refs["form"].validate((valid) => {
        if (!valid) is_valid = false;
      });
      if (!is_valid) return;
      this.is_save = true;
      // 上传文件
      for (let key in this.file_list) {
        if (!this.file_list[key].length) this.modules[key] = "";
        else if (this.file_list[key][0].raw)
          this.modules[key] = await this.uploadFile(this.file_list[key][0].raw);
      }
      let api = "modules", method = "post";
      if (this.modules.id) {
        api += "/"+this.modules.id;
        method = "put";
      }
      delete this.modules.id;
      this.$axios[method](api,this.modules).then(res=> {
        this.is_save = false;
        if (!res.code) this.$message.error(res.message);
        else {
          this.getList();
          this.open_dialog = false;
          this.$message.success("保存成功");
        }
      }).catch(err=> {
        this.is_save = false;
        this.$message.error("保存失败");
      })
    },
    /** 上传文件 **/
    uploadFile(file) {
      let form_data = new FormData();
      form_data.append("file",file);
      return this.$axios.post("uploads",form_data).then(res=> {
        if (res.code) return res.data[0];
        else return '';
      })
    },
    /** 删除报表 **/
    deleteReport(id) {
      this.$confirm('确定删除此模板?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.delete(`modules/${id}`).then(res=> {
          if (!res.code) this.$message.error(res.message);
          else {
            this.getList();
            this.$message.success("删除成功");
          }
        }).catch(e=> { this.$message.error("删除失败"); })
      }).catch(() => {});
    },
    /** 下载文件 **/
    downloadFile(url) {
      window.location.href = url;
    }
  },
  mounted() {
    this.getList();
  }
}
</script>
<style lang="scss" scoped>
</style>